import React from 'react';

import VerifyEmailForm from '@components/forms/verifyEmail';

import useVerifyEmail from './hooks';

function VerifyEmail({
	isPostLogin,
	onSuccess,
	onDecline,
}: {
	onSuccess?: () => void;
	onDecline?: () => void;
	isPostLogin?: boolean;
}) {
	const { initialValues, onSubmit } = useVerifyEmail({ onSuccess });

	return (
		<VerifyEmailForm
			initialValues={initialValues}
			isPostLogin={isPostLogin}
			onDecline={onDecline}
			onSubmit={onSubmit}
		/>
	);
}

export default VerifyEmail;
